import IconAmazonS3 from 'images/icons/imports/AmazonS3.svg';
import IconCSV from 'images/icons/imports/CSV.svg';
import IconGoogle from 'images/icons/imports/GoogleSheets.svg';
import IconMySql from 'images/icons/imports/MySql.svg';
import IconRedshift from 'images/icons/imports/Redshift.svg';
import IconSnowflake from 'images/icons/imports/Snowflake.svg';

const icons: { [key: string]: any } = {
  S3: IconAmazonS3,
  CSV: IconCSV,
  'Google Sheets': IconGoogle,
  MySQL: IconMySql,
  Snowflake: IconSnowflake,
  Redshift: IconRedshift,
};

const ImporterTypeIcon = ({ type, size = '25' }: { type: string; size?: string }) => {
  const Icon = icons[type] || (() => <></>);
  return size ? <Icon style={{ width: size, height: size }} /> : <Icon />;
};

export default ImporterTypeIcon;
